import { render, staticRenderFns } from "./Composicion.vue?vue&type=template&id=7c7d1bb0&scoped=true&"
import script from "./Composicion.vue?vue&type=script&lang=js&"
export * from "./Composicion.vue?vue&type=script&lang=js&"
import style0 from "./Composicion.vue?vue&type=style&index=0&id=7c7d1bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7d1bb0",
  null
  
)

export default component.exports